export default function(data) {
var __t, __p = '';
__p += '<div class="no-results">\n  <h2>We\'re sorry, we couldn\'t find any deals that match your search</h3>\n  <div class="no-results-message">Create a deal alert to stay up-to-date and be the first to know when we have a deal that matches your search. In the meantime, check out some of our most popular deals!</div>\n</div>\n<div class="deals-feed" id="deals-feed"></div>\n';
return __p
}